module.exports = __webpack_public_path__ + "assets/img/driver-btn-42fd4170.png";